<template>
  <div class="ttam-material-upload-select-table-suggestion">
    <div v-if="suggestion.length >= 1">
      {{ $t('video_upload_side_slip_following_issues_title') }}
    </div>

    <adaptive-list-container
      v-if="suggestion.length >= 1 && suggestion.length <= MaxShowSuggestionCount + 1"
      :num="suggestion.length"
    >
      <li v-for="msg in suggestion" :key="msg" class="ttam-material-upload-select-table-suggestion-item">
        {{ formatMsg(msg) }}
      </li>
    </adaptive-list-container>

    <template v-else-if="suggestion.length >= MaxShowSuggestionCount">
      <ul>
        <li
          v-for="msg in suggestion.slice(0, MaxShowSuggestionCount)"
          :key="msg"
          class="ttam-material-upload-select-table-suggestion-item"
        >
          {{ formatMsg(msg) }}
        </li>
      </ul>
      <vi-popover
        data-testid="material-table-select-table-suggestion-uip3tr"
        placement="top"
        trigger="hover"
        width="400"
      >
        <div slot="reference" class="ttam-material-upload-select-table-suggestion-more">
          {{ $t('module_ad_creative_pendant_problem_view_more') }}
          ({{ suggestion.length }})
        </div>
        <ul>
          <li v-for="(msg, index) in suggestion" :key="msg">
            {{ index + 1 + '.' + msg }}
          </li>
        </ul>
      </vi-popover>
    </template>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api';
import { uploadTableFormatVerifyMsg } from '@tt4b/ttam-utils';
import AdaptiveListContainer from '@/components/common/adaptive-list-container/index.vue';

const MaxShowSuggestionCount = 3;
const name = 'ttam-material-upload-select-table-suggestion';

export default defineComponent({
  name,
  components: { AdaptiveListContainer },

  props: {
    suggestion: { type: Array, default: () => [] },
  },

  setup() {
    const { formatMsg } = uploadTableFormatVerifyMsg();

    return {
      formatMsg,
      MaxShowSuggestionCount,
    };
  },
});
</script>

<style lang="scss" scoped>
.ttam-material-upload-select-table-suggestion {
  ul {
    margin-top: 6px;
  }

  &-item {
    position: relative;
    color: $--color-group3-2;
  }

  &-more {
    font-weight: $font-weight-medium;
    font-size: 12px;
    line-height: 20px;

    color: $--color-group7-5;
  }
}
</style>
